module.exports = getPage;

var deprecate = require('./deprecate');

var getPageLinks = require('./get-page-links');

var HttpError = require('./http-error');

function getPage(octokit, link, which, headers) {
  deprecate("octokit.get".concat(which.charAt(0).toUpperCase() + which.slice(1), "Page() \u2013 You can use octokit.paginate or async iterators instead: https://github.com/octokit/rest.js#pagination."));
  var url = getPageLinks(link)[which];

  if (!url) {
    var urlError = new HttpError("No ".concat(which, " page found"), 404);
    return Promise.reject(urlError);
  }

  var requestOptions = {
    url: url,
    headers: applyAcceptHeader(link, headers)
  };
  var promise = octokit.request(requestOptions);
  return promise;
}

function applyAcceptHeader(res, headers) {
  var previous = res.headers && res.headers['x-github-media-type'];

  if (!previous || headers && headers.accept) {
    return headers;
  }

  headers = headers || {};
  headers.accept = 'application/vnd.' + previous.replace('; param=', '.').replace('; format=', '+');
  return headers;
}